import {authenticationService} from '../_services';

export function handleResponse(response) {
    const data = response.data ? response.data : '';
    if ([200, 201].indexOf(response.status) === -1) {
        if ([401, 403].indexOf(response.status) !== -1) {
            // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
            authenticationService.logout();
            window.location.reload(true);
        }
        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
    }
    return data;
}